import { render, staticRenderFns } from "./BaggageAllowance.vue?vue&type=template&id=837fa42c&"
import script from "./BaggageAllowance.vue?vue&type=script&lang=ts&"
export * from "./BaggageAllowance.vue?vue&type=script&lang=ts&"
import style0 from "./BaggageAllowance.vue?vue&type=style&index=0&id=837fa42c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports